import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Button, PageHeader } from "antd";
import { useDispatch } from "react-redux";
import { searchJobs } from "../../redux/actions";
import JobTable from "./JobTable";

export default () => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();

  const [data, setData] = useState({ data: [], total: 0 });

  const fetchData = (page, size, filters = {}, sort = {}) => {
    return dispatch(searchJobs(page, size, filters, sort))
      .then(({ payload }) => setData(payload));
  };

  return (
    <div className="page-wrapper">
      <PageHeader
        className="site-page-header-ghost-wrapper"
        ghost={false}
        title={intl.formatMessage({ id: "jobs" })}
        extra={[
          <Button
            key="create"
            type="primary"
            onClick={() => history.push("/jobs/create")}
          >
            {intl.formatMessage({ id: "create" })}
          </Button>,
        ]}
      />
      <JobTable fetchData={fetchData} data={data} />
    </div>
  );
};
